import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireDist } from '../node_modules/.pnpm/escape-latex@1.2.0/node_modules/escape-latex/dist/index.js';

var distExports = requireDist();
const escapeLatexLib = /*@__PURE__*/getDefaultExportFromCjs(distExports);

export { escapeLatexLib as default };
//# sourceMappingURL=index4.js.map
